import React from "react";
import { AnatomyCSTContext } from "./AnatomyCSTContext";

class AnatomyCSTProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      unitInfo: {},
    };

    this.setUnitInfo = this.setUnitInfo.bind(this);
  }

  setUnitInfo(unitInfo) {
    this.setState({ unitInfo });
  }

  render() {
    const { unitInfo } = this.state;
    return (
      <AnatomyCSTContext.Provider
        value={{
          unitInfo,
          networkId: unitInfo.networkId,
          currency: unitInfo.currency,
          timezone: unitInfo.timezone,
          setUnitInfo: this.setUnitInfo,
        }}
      >
        {this.props.children}
      </AnatomyCSTContext.Provider>
    );
  }
}

export default AnatomyCSTProvider;
